export default __webpack_public_path__ + "static/media/google.87be52cb.svg";